// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"337":"c7930047","455":"c11a3f94"}[chunkId] + ".chunk.js";
};